export default __webpack_public_path__ + "static/media/330_store03-en-web.63df8421.png";